export enum DashboardAction {
    UPDATE_LOADING = "UPDATE_LOADING",
    UPDATE_TODAY_ATTENDANCE = "UPDATE_TODAY_ATTENDANCE",
    UPDATE_PRIORITY_THING = "UPDATE_PRIORITY_THING",
    UPDATE_LEAD_REPORT_RES = "UPDATE_LEAD_REPORT_RES",
    UPDATE_ENQUIRY_REPOERT_RES = "UPDATE_ENQUIRY_REPOERT_RES",
    UPDATE_TASK_REPOERT_RES = "UPDATE_TASK_REPOERT_RES",
    UPDATE_FILTER_DATA = "UPDATE_FILTER_DATA"
}